import dayjs from 'dayjs';

import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {datetimeObjToISOString} from '../../datetime';

export const isCourseEnded = (course?: Nullable<CourseApiModel>) => {
  if (!course?.end_date) {
    return false;
  }

  return (
    course.status === 'ongoing' &&
    dayjs() >= dayjs(datetimeObjToISOString(course.end_date))
  );
};
